import React from 'react';

import {useModelsAccess} from '../../util/useModelsAccess';
import {NoAccessPage} from './NoAccessPage';

interface AccessCheckProps {
  children: React.ReactNode;
  skipCheck?: boolean;
}

const NoAccessWrapper: React.FC<AccessCheckProps> = ({children, skipCheck}) => {
  const {hasModelsAccess, isOrgMemberLoading} = useModelsAccess(skipCheck);

  if (!isOrgMemberLoading && !hasModelsAccess) {
    return <NoAccessPage contentKey={'noModelsAccess'} />;
  }

  return <>{children}</>;
};

export default NoAccessWrapper;
